"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.laggy = void 0;
const react_1 = __importDefault(require("react"));
// https://swr.vercel.app/docs/middleware#keep-previous-result
// This is an SWR middleware for keeping the data even if key changes.
const laggy = (useSWRNext) => (key, fetcher, config) => {
    // Use a ref to store previous returned data.
    const laggyDataRef = react_1.default.useRef();
    // Actual SWR hook.
    const swr = useSWRNext(key, fetcher, config);
    react_1.default.useEffect(() => {
        // Update ref if data is not undefined.
        if (swr.data != null) {
            laggyDataRef.current = swr.data;
        }
    }, [swr.data]);
    // Expose a method to clear the laggy data, if any.
    const resetLaggy = react_1.default.useCallback(() => {
        laggyDataRef.current = undefined;
    }, []);
    // Fallback to previous data if the current data is undefined.
    const dataOrLaggyData = swr.data == null ? laggyDataRef.current : swr.data;
    // Is it showing previous data?
    const isLagging = swr.data == null && laggyDataRef.current != null;
    // Also add a `isLagging` field to SWR.
    return Object.assign({}, swr, {
        data: dataOrLaggyData,
        isLoading: swr.isLoading || isLagging,
        isLagging,
        resetLaggy,
    });
};
exports.laggy = laggy;
